"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumSchema = void 0;
const zod_1 = require("zod");
const enumSchema = (value, omit) => zod_1.z.nativeEnum(value).refine((currentValue) => !(omit === null || omit === void 0 ? void 0 : omit.includes(currentValue)), {
    message: `The current value of enum is not allowed, allowed values are: ${Object.entries(value)
        .filter(([_, currentValue]) => typeof currentValue === "number" && !(omit === null || omit === void 0 ? void 0 : omit.includes(currentValue)))
        .map(([key]) => key)
        .join(", ")}`,
});
exports.enumSchema = enumSchema;
//# sourceMappingURL=enum.schema.js.map